import moment from 'moment-timezone';
import capitalize from 'lodash/capitalize';
import {
  MOMENT_FORMAT as PICKER_FORMAT,
} from 'zignal-landscape/lib/DateRangePicker';

export const API_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss[Z]';
export const NOW = 'now';

export const convertTimestringToFormat = (timeString, format, timezone, defaultValue='') => {
  return timeString && moment.tz(Helper.normalizeTimeStr(timeString), timezone).isValid()
    ? moment.tz(Helper.normalizeTimeStr(timeString), timezone).format(format)
    : defaultValue;
};

export const convertTimeStringToMoment = (timeString, format, timezoneOffset=0, method) => {
  if (typeof timezoneOffset === 'string'){
    return ((timeString === NOW)
      ? moment.utc()
      : moment.tz(timeString, format, true, timezoneOffset).utc()
    );
  }
  return ((timeString === NOW)
    ? moment.utc()
    : moment.utc(timeString, format)[method](timezoneOffset, 'seconds')
  );
};

// timestring to moment
export function convertDatePickerTimeToMoment(timeString, timezoneOffset) {
  return convertTimeStringToMoment(timeString, PICKER_FORMAT, timezoneOffset, 'subtract');
}

export function convertApiTimeToMoment(timeString, timezoneOffset) {
  return typeof timezoneOffset === 'string'
    ? moment.utc(timeString, API_TIME_FORMAT).tz(timezoneOffset)
    : moment.utc(timeString, API_TIME_FORMAT).add(timezoneOffset, 'seconds');
}


// moment to timestring
export function convertMomentToDatePickerTime(momentInstance) {
  return momentInstance.format(PICKER_FORMAT);
}

export function convertMomentToApiTime(momentInstance) {
  return momentInstance.format(API_TIME_FORMAT);
}


// timestring to different format
export function convertDatePickerTimeToApiTime(timeString, timezoneOffset) {
  return convertMomentToApiTime(convertDatePickerTimeToMoment(timeString, timezoneOffset));
}

export function convertApiTimeToDatePickerTime(timeString, timezoneOffset) {
  return convertMomentToDatePickerTime(convertApiTimeToMoment(timeString, timezoneOffset));
}


// shared function used by discover and bot-intelligence
export function convertUrlParamTimesToDatePickerTimes(start, end, timezoneOffset) {
  const times = {};
  const now = moment();
  const startMoment = start && moment(start);
  if (startMoment && startMoment.isValid() && startMoment.isBefore(now)){
    times.startDate = convertApiTimeToDatePickerTime(start, timezoneOffset);
    const endMoment = end && moment(end);
    if (endMoment && endMoment.isValid() && endMoment.isAfter(startMoment) && endMoment.isBefore(now)){
      times.endDate = convertApiTimeToDatePickerTime(end, timezoneOffset);
    }
  }
  return times;
}


// Custom Preset Helper - Should it go into landscape?
// only handles format "last <number> <period>", e.g. "last 30 days"
export function createCustomPreset(startWindow) {
  const timeStartWindow = startWindow.toLowerCase();
  const [ unparsedNumber, period ] = timeStartWindow.split(' ').slice(1);
  // need to subtract 1 when period is days to include the current day
  const number = period === 'days' ? parseInt(unparsedNumber, 10) - 1 : parseInt(unparsedNumber, 10);
  return {
    label: capitalize(timeStartWindow),
    value: timeStartWindow,
    getDates: (timezone = moment.tz.guess()) => ({
      startDate: moment().tz(timezone).subtract(number, period).startOf('day'),
      endDate: NOW,
      timeStartWindow
    })
  };
}


